import React, { createRef } from "react"
import PropTypes from "prop-types"

export class Map extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mapLoaded: false,
      googleMap: null,
      markers: [],
    }

    this.buildedMarkers = []
  }

  static propTypes = {
    mapOptions: PropTypes.object,
    height: PropTypes.any,
    width: PropTypes.any,
    markers: PropTypes.array,
    apiKey: PropTypes.string,
    onMarkerPress: PropTypes.func,
    dataCy: PropTypes.string,
  }

  static defaultProps = {
    id: "google-map",
    dataCy: "map",
    ...{
      mapOptions: {
        zoom: 8,
        center: {
          lat: -22.94980821,
          lng: -43.19095194,
        },
        disableDefaultUI: true,
      },
      height: "100vh",
      width: "100vw",
      markers: [],
      apiKey: "",
      onMarkerPress: itemEvent => {
        console.warn("onMarkerPress is not created", itemEvent)
      },
    },
  }

  googleMapRef = createRef()

  componentDidMount() {
    const { markers } = this.props

    this.initMap()
      .then(googleMap => {
        this.props.getMap(googleMap)

        for (let i = 0; i < markers.length; i++) {
          const { lat, lng, options } = markers[i]
          this.buildedMarkers[i] = this.createMarker(lat, lng, options)
          this.buildedMarkers[i].addListener("click", () =>
            this.handleClick(this.buildedMarkers[i]),
          )
        }
      })
      .catch(err => console.error(err))
  }

  componentDidUpdate() {
    const { markers } = this.props

    this.resetMarker(markers, this.buildedMarkers)
  }

  createGoogleMap = () => {
    const { mapOptions } = this.props
    return new window.google.maps.Map(this.googleMapRef.current, {
      ...mapOptions,
    })
  }

  initMap = () => {
    return new Promise((resolve, reject) => {
      const { apiKey } = this.props
      const googleMapScript = document.createElement("script")
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=&v=weekly`
      window.document.body.appendChild(googleMapScript)

      let googleMap
      googleMapScript.onload = () => {
        googleMap = this.createGoogleMap()
        this.setState({ mapLoaded: true, googleMap })
        resolve(googleMap)
      }
    })
  }

  createMarker = (lat, lng, options) => {
    return new window.google.maps.Marker({
      position: { lat, lng },
      map: this.state.googleMap,
      ...options,
    })
  }

  resetMarker = (markers, buildedMarkers) => {
    if (this.buildedMarkers.length !== 0) {
      for (let i = 0; i < this.buildedMarkers.length; i++) {
        this.buildedMarkers[i].setMap(null)
      }

      for (let i = 0; i < markers.length; i++) {
        const { lat, lng, options } = markers[i]
        this.buildedMarkers[i] = this.createMarker(lat, lng, options)
        this.buildedMarkers[i].addListener("click", () =>
          this.handleClick(this.buildedMarkers[i]),
        )
      }
    }
  }

  handleClick = itemEvent => {
    this.props.onMarkerPress(itemEvent)
  }

  render() {
    const { id, height, width, dataCy } = this.props

    return (
      <div
        data-cy={dataCy}
        style={{ height, width }}
        id={id}
        ref={this.googleMapRef}
      />
    )
  }
}

//Solução TS Marcador Não esta funcionando
// import React, { createRef, useCallback, useEffect, useState } from 'react'
// import { MapProps } from './examples/types'

// export const Map: React.FC<MapProps> = ({
//   dataCy = 'map',
//   mapOptions = {
//     zoom: 8,
//     center: {
//       lat: -22.94980821,
//       lng: -43.19095194
//     },
//     disableDefaultUI: true
//   },
//   height = '100vh',
//   width = '100vw',
//   markers = [],
//   apiKey = '',
//   getMap,
//   onMarkerPress = (itemEvent) => {
//     console.warn('onMarkerPress is not created', itemEvent)
//   }
// }) => {
//   const [mapLoaded, setMapLoaded] = useState(false)
//   const [googleMap, setGoogleMap] = useState(null)
//   //   const [markers, setMarkers] = useState([])
//   const buildedMarkers: any = []
//   const googleMapRef = createRef<any>()

//   const createMarker = useCallback((lat, lng, options) => {
//     return new window.google.maps.Marker({
//       position: { lat, lng },
//       map: googleMap,
//       ...options
//     })
//   }, [])

//   const handleClick = useCallback(
//     (itemEvent) => {
//       onMarkerPress(itemEvent)
//     },
//     [onMarkerPress]
//   )

//   const resetMarker = useCallback(
//     (markers, buildedMarkers) => {
//       if (buildedMarkers.length !== 0) {
//         for (let i = 0; i < buildedMarkers.length; i++) {
//           buildedMarkers[i].setMap(null)
//         }

//         for (let i = 0; i < markers.length; i++) {
//           const { lat, lng, options } = markers[i]
//           buildedMarkers[i] = createMarker(lat, lng, options)
//           buildedMarkers[i].addListener('click', () =>
//             handleClick(buildedMarkers[i])
//           )
//         }
//       }
//     },
//     [createMarker, handleClick]
//   )

//   const createGoogleMap = useCallback(() => {
//     return new window.google.maps.Map(googleMapRef.current, {
//       ...mapOptions
//     })
//   }, [googleMapRef, mapOptions])

//   const initMap = useCallback(() => {
//     return new Promise((resolve, reject) => {
//       const googleMapScript = document.createElement('script')
//       googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=&v=weekly`
//       window.document.body.appendChild(googleMapScript)

//       let googleMap
//       googleMapScript.onload = () => {
//         googleMap = createGoogleMap()
//         setGoogleMap(googleMap)
//         setMapLoaded(true)

//         resolve(googleMap)
//       }
//     })
//   }, [apiKey, createGoogleMap])

//   useEffect(() => {
//     initMap()
//       .then((googleMap: any) => {
//         getMap(googleMap)

//         for (let i = 0; i < markers.length; i++) {
//           const { lat, lng, options } = markers[i]
//           buildedMarkers[i] = createMarker(lat, lng, options)
//           buildedMarkers[i].addListener('click', () =>
//             handleClick(buildedMarkers[i])
//           )
//         }
//       })
//       .catch((err) => console.error(err))
//   }, [])

//   useEffect(() => {
//     resetMarker(markers, buildedMarkers)
//   }, [buildedMarkers, markers, resetMarker])

//   return (
//     <div
//       data-cy={dataCy}
//       style={{ height, width }}
//       id={'google-map'}
//       ref={googleMapRef}
//     />
//   )
// }
